// @ts-nocheck
import { Plugin } from '/src/packages/www/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','getInitialState','initialStateConfig',],
});

export { plugin };
